import { render } from "./login.vue?vue&type=template&id=2dccd1f4&scoped=true&ts=true"
import script from "./login.vue?vue&type=script&lang=ts"
export * from "./login.vue?vue&type=script&lang=ts"

import "./login.vue?vue&type=style&index=0&id=2dccd1f4&lang=scss&scoped=true"

import exportComponent from "D:\\0_Winth\\Yangbang source code\\20221221\\yb_web_new_01\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dccd1f4"]])

export default __exports__